import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const DragIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 32 32">
      {/* <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 0H5C4.45 0 4 0.45 4 1V3H6V2H14V9H13V11H15C15.55 11 16 10.55 16 10V1C16 0.45 15.55 0 15 0ZM11 4H1C0.45 4 0 4.45 0 5V15C0 15.55 0.45 16 1 16H11C11.55 16 12 15.55 12 15V5C12 4.45 11.55 4 11 4ZM10 14H2V6H10V14Z"
        fill="currentColor"
      /> */}

      <rect x="10" y="6" width="4" height="4" fill="currentColor" />
      <rect x="18" y="6" width="4" height="4" fill="currentColor" />
      <rect x="10" y="14" width="4" height="4" fill="currentColor" />
      <rect x="18" y="14" width="4" height="4" fill="currentColor" />
      <rect x="10" y="22" width="4" height="4" fill="currentColor" />
      <rect x="18" y="22" width="4" height="4" fill="currentColor" />
    </BaseIcon>
  );
};

export default DragIcon;
